import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export class RadioInput extends Component {
  static propTypes = {
    input: PropTypes.shape().isRequired,
    meta: PropTypes.shape().isRequired,
    item: PropTypes.oneOfType([
      PropTypes.shape(),
      PropTypes.string,
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node)
    ]),
    iValue: PropTypes.string.isRequired,
    reset: PropTypes.func.isRequired
  };

  static defaultProps = {
    item: null
  };

  static isChecked(modelValue, inputValue) {
    return (
      (modelValue
        && modelValue.length
        && typeof modelValue !== 'string'
        && modelValue.indexOf(inputValue) !== -1)
      || (modelValue
        && modelValue.length
        && typeof modelValue === 'string'
        && modelValue === inputValue)
      || (modelValue === true
        && inputValue === 'true')
      || (modelValue === false
        && inputValue === 'false')
    );
  }

  static hasWrongCheck(modelValue, inputValue) {
    return modelValue
    && modelValue.length > 1
    && RadioInput.isChecked(modelValue, inputValue);
  }

  constructor(props) {
    super(props);
    this.state = { isReset: false };
  }

  handleChanges(event) {
    const {
      input,
      meta,
      iValue,
      reset
    } = this.props;
    const { isReset } = this.state;
    if (
      !isReset
      && RadioInput.isChecked(input.value, iValue)
    ) {
      this.setState({ isReset: true });
      reset(
        meta.form,
        input.name
      );
    } else {
      this.setState({ isReset: false });
      input.onChange(event);
    }
  }

  render() {
    const {
      input,
      item,
      iValue
    } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label className="form-checkbox">
        <input
          type="radio"
          { ...input }
          value={ iValue }
          checked={ RadioInput.isChecked(input.value, iValue) }
          onClick={ event => this.handleChanges(event) }
          onBlur={ null }
          className={ `${ RadioInput.hasWrongCheck(input.value, iValue) ? 'has-wrong-check' : '' }` }
        />
        <i className="form-icon" />
        { item }
      </label>
    );
  }
}
